<template>
  <div class="bind-phone">
    <div class="topbar">
      <TopBar :imgsrc="logo" color="#000" />
    </div>
    <div class="content">
      <p class="title">绑定手机号</p>
      <el-form
        label-position="right"
        label-width="100px"
        :rules="rules"
        :model="contentObj"
      >
        <el-form-item label="手机号" prop="phone">
          <el-input
            type="text"
            placeholder="请输入手机号"
            v-model="contentObj.phone"
            maxlength="11"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="captcha">
          <div class="verification-code-container">
            <el-input
              type="text"
              placeholder="请输入验证码"
              v-model="contentObj.captcha"
              maxlength="6"
              show-word-limit
              class="verification-code-input"
            ></el-input>
            <el-button
              @click="getVerificationCode"
              class="captcha-btn"
              :disabled="isCodeDisabled"
            >
              {{ codeButtonText }}
            </el-button>
          </div>
        </el-form-item>

        <el-form-item>
          <div class="btnList">
            <button class="sucess" @click.prevent="handleBindPhone">
              确认
            </button>
            <button class="del">取消</button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import TopBar from "@/views/supermarket/TopBar/index.vue";
import { Message } from "element-ui";
import { getCode, BindPhone, Login } from "@/api/user";
import logo from "@/assets1/logo_slices/编组 2(1).png";
export default {
  data() {
    return {
      logo,
      isCodeDisabled: false,
      codeButtonText: "获取验证码",
      countdown: 60,
      contentObj: {
        phone: "",
        captcha: "",
      },
      token: "",
      rules: {
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  components: {
    TopBar,
  },
  methods: {
    async getVerificationCode() {
      // 这里添加获取验证码的逻辑
      console.log("获取验证码");

      // 开始倒计时

      const res = await getCode({
        phone: this.contentObj.phone,
        reason: "login",
        mock: false,
      });
      console.log(res);
      this.isCodeDisabled = true;
      this.countdown = 60;
      this.codeButtonText = `${this.countdown}s后重新获取`;
      this.token = res.phone_token;

      const timer = setInterval(() => {
        this.countdown--;
        this.codeButtonText = `${this.countdown}s后重新获取`;

        if (this.countdown <= 0) {
          clearInterval(timer);
          this.isCodeDisabled = false;
          this.codeButtonText = "获取验证码";
        }
      }, 1000);
    },
    async handleBindPhone() {
      const res = await BindPhone({
        phone: this.contentObj.phone,
        verification_code: this.contentObj.captcha,
        phone_token: this.token,
        auth_token: this.$store.state.Auth_token,
      });
      const loginRes = await Login({
        login_type: 2,
        public_key: this.$store.state.public_key,
        nonce: this.$store.state.nonce,
        signature: this.$store.state.signature,
      });
      console.log(loginRes);
      if (loginRes.user) {
        this.$store.commit("setUid", loginRes.user?.id);
        Message({
          message: `绑定成功`,
          type: "success",
        });
        console.log(this.$store, "res");

        localStorage.setItem("token", `Bearer ${res.access_token}`);
        sessionStorage.setItem("token", `Bearer ${res.access_token}`);
        this.$router.push("/informationCompletion");
      }
    },
  },
};
</script>

<style scoped>
.btnList button {
  width: 80px;
  height: 32px;
  border: 1px solid #e9e9e9;
  margin-right: 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px;
}
::v-deep .el-input {
  width: 570px;
  height: 36px;
}

::v-deep .verification-code-input {
  width: 370px;
  height: 36px;
}
.verification-code-container {
  display: flex;
  align-items: center;
  width: 570px;
  gap: 20px;
}

.captcha-btn {
  margin-left: auto;
  height: 36px;
  font-size: 14px;
  padding: 0 15px;
  white-space: nowrap;
  flex-shrink: 0;
}
.content > p {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 24px;
}
.content {
  width: 1024px;
  background-color: #fff;
  height: 570px;
  margin: 0 auto;
  border-radius: 10px;
  padding: 24px;
}
.bind-phone {
  background-color: #f7f8fc;
  height: 100vh;
}
.topbar {
  min-width: 1920px;
  height: 220px;
  background-image: url("../../../../assets1/已发布数据集-已选_slices/位图.png");
  margin-bottom: 10px;
}
</style>
